import type {
  News,
  Activity,
  Category,
  Employee,
  MeetingAgendaPointTemplate,
} from "@/graphql/generated-types";
import toFileState from "@/helpers/files/toFileState";
import { type IFileState } from "@/interfaces";

interface MediaHolder {
  image?: Category["image"] | Employee["image"];
  picture?: MeetingAgendaPointTemplate["picture"];
  coverImage?: News["coverImage"] | Activity["coverImage"];
  pictures?: News["pictures"] | Activity["pictures"];
}

export default (item: MediaHolder): IFileState[] => {
  const result: IFileState[] = [];

  const image = item.coverImage || item.image || item.picture;
  if (image && image.id !== "-1") {
    result.push(toFileState(image.source, "image", image.id, true));
  }

  result.push(
    ...(item.pictures || [])
      .filter((item) => item.id !== "-1")
      .map((picture) => toFileState(picture.source, "image", picture.id)),
  );

  return result;
};
